import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { useLang } from "@/lib/i18n";

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export function LangSwitcher() {
  const { lang, setLang } = useLang();
  return (
    <div
      className="flex items-center rounded-full border border-[#C5B358]/50 overflow-hidden"
      data-testid="lang-switcher"
      role="group"
      aria-label="Language"
    >
      {["en", "es"].map((l) => (
        <button
          key={l}
          data-testid={`lang-btn-${l}`}
          onClick={() => setLang(l)}
          aria-pressed={lang === l}
          className={`px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.15em] transition-all duration-200 ${
            lang === l ? "bg-[#C5B358] text-[#0F1E3D]" : "text-[#A3B1C6] hover:text-[#C5B358]"
          }`}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}

export default function Nav() {
  const { t } = useLang();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 32);
    fn();
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0F1E3D] backdrop-blur-md border-b border-[#C5B358]/20" : "bg-transparent"
      }`}
    >
      <nav className="max-w-[1320px] mx-auto flex items-center justify-between px-6 lg:px-10 h-[72px]">
        <Logo light />
        <div className="hidden lg:flex items-center gap-9">
          {t.nav.links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollToSection(l.id)}
              className="eyebrow text-[#A3B1C6] hover:text-[#C5B358] transition-colors duration-200"
            >
              {l.label}
            </button>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <LangSwitcher />
          <a
            href="https://atlantisintl.wixforms.com/f/7491626155519247389"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-cta-enterprise"
            className="group hidden sm:flex items-center gap-2 border border-[#C5B358]/70 text-[#C5B358] hover:bg-[#C5B358] hover:text-[#0F1E3D] transition-all duration-300 rounded-full px-5 py-2.5"
          >
            <span className="eyebrow">{t.nav.cta}</span>
            <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
      </nav>
    </header>
  );
}